import React from 'react';
import { Link } from 'react-router-dom';
import ZoomOutTextEffect from './ZoomOutTextEffect';
import './DarkBlueCTA.css';

const DarkBlueCTA = () => {
  return (
    <section className="dark-blue-cta">
      <div className="dark-blue-background"></div>
      <div className="container">
        <ZoomOutTextEffect>
          <h2 className="cta-title">Ready to Transform Your Business?</h2>
          <p className="cta-description">Partner with Hyperion AI to unlock the full potential of artificial intelligence for your organization.</p>
        </ZoomOutTextEffect>
        <Link to="/contact-us" className="cta-button">Get Started Today</Link>
      </div>
    </section>
  );
};

export default DarkBlueCTA;
